import { render } from "./ConsumerExtraOffers.vue?vue&type=template&id=1a4d6a1c&scoped=true"
import script from "./ConsumerExtraOffers.vue?vue&type=script&lang=js"
export * from "./ConsumerExtraOffers.vue?vue&type=script&lang=js"

import "./ConsumerExtraOffers.vue?vue&type=style&index=0&id=1a4d6a1c&scoped=true&lang=css"
import "./ConsumerExtraOffers.vue?vue&type=style&index=1&id=1a4d6a1c&lang=css"
script.render = render
script.__scopeId = "data-v-1a4d6a1c"

export default script